export const base64Encode = (toBeEncoded:string) => {
  return Buffer.from(toBeEncoded).toString('base64')
}

export const base64Decode = (toBeDecoded:string) => {
  return Buffer.from(toBeDecoded, 'base64').toString('ascii')
}
